export var isMax = function isMax(config) {
  return (config === null || config === void 0 ? void 0 : config.clientId) === "98a4ea4028d47686c954d430b36af8aa288eccdfc8a9e28afcd1a266ec01252f";
};
export var isReloy = function isReloy(config) {
  return (config === null || config === void 0 ? void 0 : config.clientId) === "43f9ae0bd0e04f52e4d95b93bcf34138dbf6052b78dc2710ff4eb90b3c69f096";
};
export var isOmsree = function isOmsree(config) {
  return (config === null || config === void 0 ? void 0 : config.clientId) === "cc645dd19374b46897006c51b38df296025d3afda7ee0951c88a049845dae142";
};
export var isGodrej = function isGodrej(config) {
  return (config === null || config === void 0 ? void 0 : config.clientId) === "4757d92ecbc85bd93320870e1d15ae79788920c0cbf41abe884bfbc4980a0c08";
};
export var isMahindra = function isMahindra(config) {
  return (config === null || config === void 0 ? void 0 : config.clientId) === "89f7c75cc7d56d4969a90431f3aa0bf6dff0f21e8656455ae0068483f578584a";
};
export var isBirla = function isBirla(config) {
  return (config === null || config === void 0 ? void 0 : config.clientId) === "707fc887817bec30baa040d88710a6989a8ae9f9ed9c115bedcdd710f0ec7d56";
};
export var isDosti = function isDosti(config) {
  return (config === null || config === void 0 ? void 0 : config.clientId) === "35dd5a10968a45d11268b3a069aaf9f10121fd2bdbe025a76ba3cc5af75666c8";
};
export var isM3M = function isM3M(config) {
  return (config === null || config === void 0 ? void 0 : config.clientId) === "519cccdf78f4f5a1f65ea6831f6eca84f48983b90c999e50d91fbe92247e82ea";
};
export var isDuville = function isDuville(config) {
  return (config === null || config === void 0 ? void 0 : config.clientId) === "4bc49f5062ec2912c1b6c5db3696bb799bed857998cad45f9027958b62cd2d9e";
};
export var isSmartWorldCare = function isSmartWorldCare(config) {
  return (config === null || config === void 0 ? void 0 : config.clientId) === "03684311049f5cd78c9b0d8a932d4ea6e10af7e6f3ded89a860462321670b8bd";
};
export var isAjmera = function isAjmera(config) {
  return (config === null || config === void 0 ? void 0 : config.clientId) === "1879e2bd97969b10daee96c287081c6d01828015f28a06b0eccc08b348e3ea89";
};
export var isAshar = function isAshar(config) {
  return (config === null || config === void 0 ? void 0 : config.clientId) === "33e9719898f659574d1e5008b09393501198d8c998f849b7783de669c80d41a9";
};
export var isArkade = function isArkade(config) {
  return (config === null || config === void 0 ? void 0 : config.clientId) === "c791e6920108e5e34aa4ffbfebcc82a4c214f993779d62ac98105d6143bc35bb";
};
export var isChandak = function isChandak(config) {
  return (config === null || config === void 0 ? void 0 : config.clientId) === "f29f4282be0c8a96ebbf01c423292eef62d963a978d571a64ac9b017d30ad0f9";
};
export var isEden = function isEden(config) {
  return (config === null || config === void 0 ? void 0 : config.clientId) === "9a5a10777315248202e7c6f8d719e0d82482ec87e7b54d332db11895520e92f9";
};
export var isKrc = function isKrc(config) {
  return (config === null || config === void 0 ? void 0 : config.clientId) === "89dcfa41903ebba52c0b371d5dcdddb67e8bfd8daf8fea6019ada584de2af9ca";
};
export var isAloha = function isAloha(config) {
  return (config === null || config === void 0 ? void 0 : config.clientId) === "239c65cb76f499014d6585d35a253fa1d6a967239b6953701af8c8fe9d24c526";
};
export var isAdani = function isAdani(config) {
  return (config === null || config === void 0 ? void 0 : config.clientId) === "d8b0f9ddbc11b3121dae65f540384ba90b272a5bbbbb80576e7f9ae016469e44";
};